import { createClient } from 'pexels';

const client = createClient(import.meta.env.VITE_PEXELS_API_KEY);

export const videoService = {
  async searchVideos(query, perPage = 5, options = {}) {
    try {
      const response = await client.videos.search({
        query,
        per_page: perPage,
        orientation: 'landscape',
        size: 'medium',
        ...options
      });

      return response.videos.map(video => ({
        id: video.id,
        duration: video.duration,
        description: video.url,
        width: video.width,
        height: video.height,
        thumbnail: video.image,
        user: {
          name: video.user.name,
          url: video.user.url
        },
        files: video.video_files.map(file => ({
          quality: file.quality,
          fileType: file.file_type,
          width: file.width,
          height: file.height,
          link: file.link
        })),
        preview: {
          mp4: video.video_files.find(f => f.quality === 'sd' && f.file_type === 'video/mp4')?.link,
          webm: video.video_files.find(f => f.quality === 'sd' && f.file_type === 'video/webm')?.link
        }
      }));
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error searching Pexels videos:', error);
      }
      throw error;
    }
  },

  getBestVideoFile(video, preferredQuality = 'hd') {
    const qualityOrder = ['hd', 'sd', 'mobile'];
    const preferredFile = video.files.find(f => f.quality === preferredQuality);
    
    if (preferredFile) return preferredFile;

    // Fall back to next best quality
    for (const quality of qualityOrder) {
      const file = video.files.find(f => f.quality === quality);
      if (file) return file;
    }

    return video.files[0]; // Last resort: return first available file
  }
}; 